import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ThumbsUpFilled({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M8 8.66671H4V20H8V18.6667V10.3334V8.66671ZM9.33333 10.3334L9.33333 18.6667H16.1207C17.2477 18.6667 18.253 17.9583 18.6321 16.8969L20.0606 12.8969C20.6809 11.1603 19.3934 9.33337 17.5493 9.33337H14L15.1972 5.02357C15.4332 4.17397 14.7942 3.33337 13.9125 3.33337H13.3333L9.33333 10.3334Z"
        fill={iconColor}
      />
    </Svg>
  );
}
